/**
 * @fileoverview Taskflow - Actions Bar component React interface.
 * @author Qiwen Luo (qluo@yext.com)
 */

import {Button} from '/ui/components/button/button';
import {SmallDialog} from '/ui/components/modal/dialog';
import * as Types from '/ui/components/taskflow/models';
import {yext} from '/ui/lib/msg';

import * as styles from '/ui/components/taskflow/actionsBar/actionsBar.module.scss';

/**
 * @typedef {{
 *    ctas: !Array<React.ReactNode>,
 *    onBack?: (function(): void),
 *    onCancel?: (function(): void),
 *    padding?: boolean,
 *    onCancelDialog?: Types.onCancelDialogType,
 *    pendoId?: string,
 * }}
 */
export let ActionsBarProps;

/**
 * @param {ActionsBarProps} props
 * @return {React.ReactElement}
 */
export function ActionsBar({
  ctas,
  onBack,
  onCancel,
  padding=false,
  onCancelDialog,
  pendoId,
}) {
  const [showDialog, setShowDialog] = React.useState(false);
  const containerStyle = ['js-taskflow-desktop-actionsBar', styles.container];
  if (padding) containerStyle.push(styles.padding);

  return (
    <div className={containerStyle.join(' ')}>
      {onCancelDialog && (
        <Button
          chromeless={true}
          onClick={() => setShowDialog(true)}
          pendoId={pendoId && pendoId + '-cancel'}>
          {yext.msg('Cancel')}
        </Button>
      )}
      <div className={styles.rightActions}>
        {onBack && (
          <Button
            chromeless={true}
            onClick={onBack}
            pendoId={pendoId && pendoId + '-back'}>
            {yext.msg('Back')}
          </Button>
        )}
        {ctas.map((cta, index) => <React.Fragment key={index}>{cta}</React.Fragment>)}
      </div>
      {onCancelDialog && (
        <SmallDialog
          title={onCancelDialog.title}
          callToAction={{
            cancel: {
              type: 'cancel',
              text: yext.msg('Cancel'),
            },
            primary: {
              type: 'destructive',
              text: onCancelDialog.primaryCTALabel,
              callback: () => {
                onCancel && onCancel();
                setShowDialog(false);
              },
            },
          }}
          show={showDialog}
          onHideDialog={() => setShowDialog(false)}
        >
          {onCancelDialog.children}
        </SmallDialog>
      )}
    </div>
  );
}
